/* eslint-disable import/prefer-default-export */
import Clients from '../../api/Clients';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';
import {
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAILURE,
  GET_CLIENT_BY_RUT_REQUEST,
  GET_CLIENT_BY_RUT_SUCCESS,
  GET_CLIENT_BY_RUT_FAILURE,
  GET_CLIENT_PORTAL,
  GET_CLIENT_PORTAL_SUCCESS,
  GET_CLIENT_PORTAL_FAILURE,
  CREATE_CLIENT,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  UPDATE_CLIENT_PASSWORD,
  UPDATE_CLIENT_PASSWORD_SUCCESS,
  UPDATE_CLIENT_PASSWORD_FAILURE,
  GET_CLIENT_EXISTS,
  GET_CLIENT_EXISTS_SUCCESS,
  GET_CLIENT_EXISTS_FAILURE
} from '../../api/Types';

export const getClients = (query, cb) => async (dispatch) => {
  dispatch({ type: GET_CLIENTS_REQUEST });
  try {
    const { body, header } = await Clients.get(query);
    const count = header['x-pagination-total-count'];
    const limit = header['x-pagination-limit'];
    if (cb) {
      cb(body);
    }
    dispatch({ type: GET_CLIENTS_SUCCESS, payload: { body, count, limit } });
  } catch (error) {
    dispatch({ type: GET_CLIENTS_FAILURE, error });
    console.log('error: \n', error);
    BasicNotification.error('Ocurrió un error al intentar obtener los clientes.');
  }
};

export const getClientByRut = (rut, cb) => async (dispatch) => {
  dispatch({ type: GET_CLIENT_BY_RUT_REQUEST });
  try {
    const { body } = await Clients.getByRut(rut);
    if (cb) {
      cb(body);
    }
    dispatch({ type: GET_CLIENT_BY_RUT_SUCCESS, body });
  } catch (error) {
    dispatch({ type: GET_CLIENT_BY_RUT_FAILURE, error });
    BasicNotification.error('Ocurrió un error al intentar obtener el cliente.');
  }
};

export const getClientPortal = (rut, cb) => async (dispatch) => {
  dispatch({ type: GET_CLIENT_PORTAL });
  try {
    const { body } = await Clients.getClientPortal(rut);
    if (cb) {
      cb(body);
    }
    dispatch({ type: GET_CLIENT_PORTAL_SUCCESS, body });
  } catch (error) {
    dispatch({ type: GET_CLIENT_PORTAL_FAILURE, error });
    BasicNotification.error('Ocurrió un error al intentar obtener el cliente en portal.');
  }
};

export const getClientExistsTrinidad = (rut, cb) => async (dispatch) => {
  dispatch({ type: GET_CLIENT_EXISTS });
  try {
    const { body } = await Clients.getClientExists(rut);
    if (cb) {
      cb(body);
    }
    dispatch({ type: GET_CLIENT_EXISTS_SUCCESS, body });
  } catch (error) {
    dispatch({ type: GET_CLIENT_EXISTS_FAILURE, error });
    BasicNotification.error('Ocurrió un error al intentar consular la existencia del Cliente');
  }
};

export const createClient = (data, cb) => async (dispatch) => {
  dispatch({ type: CREATE_CLIENT, loading: true });
  try {
    BasicNotification.info('Agregando a portal cliente');
    const { body } = await Clients.createClient(data);
    console.log('body nuevo clietne', body);
    if (cb) {
      cb(body);
    }
    dispatch({ type: CREATE_CLIENT_SUCCESS, loading: false, payload: { subType: body } });
    BasicNotification.success('Cliente agregado con éxito');
  } catch (error) {

    if (error.status === 400) {
      BasicNotification.error('Cliente ya existe', error);
    } else {
      BasicNotification.error('Error al agregar cliente', error);
    }
    dispatch({ type: CREATE_CLIENT_FAILURE, loading: false, error: error.status });
  }
};

export const updateClientPassword = (data, cb) => async (dispatch) => {
  dispatch({ type: UPDATE_CLIENT_PASSWORD, loading: true });
  BasicNotification.info('Enviando correo con nueva contraseña...');
  try {
    await Clients.updateClientPassword(data.dni, data.email, data.name);
    if (cb) {
      cb();
    }
    dispatch({ type: UPDATE_CLIENT_PASSWORD_SUCCESS, loading: false });
    BasicNotification.success('Correo enviado con éxito.');
  } catch (error) {
    console.error(error);
    dispatch({ type: UPDATE_CLIENT_PASSWORD_FAILURE, loading: false, payload: { error } });
    BasicNotification.error('Ocurrió un error al intentar enviar el correo');
  }
};
